export default __webpack_public_path__ + "static/media/logo-dark.506bfa9b.svg";